module.exports = __webpack_public_path__ + "static/img/2s-img3.0fa256b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/2s-img3.png
// module id = laUw
// module chunks = 0